angular.module('impactx.themeworld').service('ThemeWorldService', ThemeWorldService);

ThemeWorldService.$inject = ['dataGen', 'TranslationService', 'ToastService', '$context', '$q', 'searchFilter', '$redirect', 'cookieService'];

function ThemeWorldService(dataGen, TranslationService, ToastService, $context, $q, searchFilter, $redirect, cookieService) {
    var validProducts = [];
    var invalidProducts = [];
    var lotFilter = [];

    //initially set this to true. So it is true, if a user uses CTRL+F5 while themeworld is active.
    var currentThemeWorldHasBeenChanged = true;

    function addProductsToThemeWorld(products) {
        var proIds = [];
        angular.forEach(products, function(product) {
            product.basketLink.canAddToThemeWorld = false;
            product.basketLink.canRemoveFromThemeWorld = true;
            proIds.push(product.id);
        });
        return dataGen.postAsForm({}, {vcatId: $context.hasActiveThemeWorld.id, proIds: proIds}, "/themeworld/add/product").then(function() {
            ToastService.openStandardToast(TranslationService.get('addSuccess'));
            currentThemeWorldHasBeenChanged = true;
        });
    }

    function addTendersToThemeWorld(tenders) {
        var tenderIds = [];
        angular.forEach(tenders, function(tender) {
            tender.canAddToThemeWorld = false;
            tenderIds.push(tender.id);
        });
        return dataGen.postAsForm({}, {vcatId: $context.hasActiveThemeWorld.id, tenderIds: tenderIds}, "/themeworld/add/tender").then(function() {
            ToastService.openStandardToast(TranslationService.get('addSuccess'));
            currentThemeWorldHasBeenChanged = true;
        });
    }

    function addLotsToThemeWorld(lots) {
        var lotIds = [];
        angular.forEach(lots, function(lot) {
            lot.canAddToThemeWorld = false;
            lotIds.push(lot.id);
        });
        return dataGen.postAsForm({}, {vcatId: $context.hasActiveThemeWorld.id, lotIds: lotIds}, "/themeworld/add/lot").then(function() {
            ToastService.openStandardToast(TranslationService.get('addSuccess'));
            currentThemeWorldHasBeenChanged = true;
        });
    }

    function addVCatsToThemeWorld(vCats) {
        var vCatIds = [];
        angular.forEach(vCats, function(vCat) {
            vCat.canAddToThemeWorld = false;
            vCatIds.push(vCat.id);
        });
        return dataGen.postAsForm({}, {vcatId: $context.hasActiveThemeWorld.id, vCatIds: vCatIds}, "/themeworld/add/vcat").then(function() {
            ToastService.openStandardToast(TranslationService.get('addSuccess'));
            currentThemeWorldHasBeenChanged = true;
        });
    }

    function addSuppliersToThemeWorld(suppliers) {
        var supplierIds = [];
        angular.forEach(suppliers, function(supplier) {
            supplier.canAddToThemeWorld = false;
            supplierIds.push(supplier.id);
        });
        return dataGen.postAsForm({}, {vcatId: $context.hasActiveThemeWorld.id, suppliers: supplierIds}, "/themeworld/add/supplier").then(function() {
            ToastService.openStandardToast(TranslationService.get('addSuccess'));
            currentThemeWorldHasBeenChanged = true;
        });
    }

    function removeProductsFromThemeWorld(vcatId, products) {
        return dataGen.postAsForm({}, {vcatId: vcatId, proIds: products}, "/themeworld/remove/product").then(function() {
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
            currentThemeWorldHasBeenChanged = true;
        });
    }

    function removeTendersFromThemeWorld(vcatId, tenders) {
        return dataGen.postAsForm({}, {vcatId: vcatId, tenderIds: tenders}, "/themeworld/remove/tender").then(function() {
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
            currentThemeWorldHasBeenChanged = true;
        });
    }

    function removeLotsFromThemeWorld(vcatId, lots) {
        return dataGen.postAsForm({}, {vcatId: vcatId, lotIds: lots}, "/themeworld/remove/lot").then(function() {
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
            currentThemeWorldHasBeenChanged = true;
        });
    }

    function removeVCatsFromThemeWorld(vcatId, vCats) {
        return dataGen.postAsForm({}, {vcatId: vcatId, vCatIds: vCats}, "/themeworld/remove/vcat").then(function() {
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
            currentThemeWorldHasBeenChanged = true;
        });
    }

    function removeSuppliersFromThemeWorld(vcatId, suppliers) {
        return dataGen.postAsForm({}, {vcatId: vcatId, suppliers: suppliers}, "/themeworld/remove/supplier").then(function() {
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
            currentThemeWorldHasBeenChanged = true;
        });
    }

    function deactivateActiveThemeWorld() {
        if($context.hasActiveThemeWorld && $context.hasActiveThemeWorld.value) {
            var needsIndexTemp = needsIndex();
            currentThemeWorldHasBeenChanged = false;
            return dataGen.postAsForm({}, {needsIndex: needsIndexTemp}, "/themeworld/deactivate");
        }
        else {
            return $q.when();
        }
    }

    function deactivateActiveThemeWorldSearch(deactivateOnBackend) {
        $context.hasActiveThemeWorldSearch.theme = undefined;
        if(deactivateOnBackend) {
            if($context.hasActiveThemeWorldSearch && $context.hasActiveThemeWorldSearch.value) {
                return dataGen.postAsForm({}, {}, "/themeworld/deactivatesearch");
            }
            else {
                return $q.when();
            }
        }
    }

    function activateThemeWorld(id) {
        currentThemeWorldHasBeenChanged = false;
        dataGen.postAsForm({}, {id: id}, "/themeworld/activate").then(function (data) {
            $context.refreshSearchInfo({}, dataGen, $context).then(function () {
                ToastService.openStandardToast(data.trns.themeWorldActivated);
            });
        });
    }

    function activateThemeWorldSearch(id) {
        dataGen.postAsForm({}, {id: id}, "/themeworld/activatesearch").then(function(data) {
            $context.hasActiveThemeWorldSearch.theme = data.data.theme;
            $context.refreshSearchInfo({}, dataGen, $context).then(function() {
                searchFilter.resetSearchFilter();
                ToastService.openStandardToast(data.trns.themeWorldActivated);
                $redirect.redirectTo(null, "/search/themeworld/" + id);
            });
        });
    }

    function getCurrentThemeWorldSearch() {
        return $context.hasActiveThemeWorldSearch ? $context.hasActiveThemeWorldSearch.theme : undefined;
    }

    function needsIndex() {
        return currentThemeWorldHasBeenChanged;
    }

    function addAllProductConfigsToThemeWorld(products, event) {
        var proIds = [];
        angular.forEach(products, function(product) {
            product.basketLink.canAddToThemeWorld = false;
            product.basketLink.canRemoveFromThemeWorld = true;
            product.basketLink.hasOtherConfigurationsInThemeWorld = true;
            product.basketLink.hasOtherConfigurationsNotInThemeWorld = false;
            proIds.push(product.id);
        });
        return dataGen.postAsForm({}, {vcatId: $context.hasActiveThemeWorld.id, proIds: proIds, }, "/themeworld/add/product/allconfigurations").then(function() {
            ToastService.openStandardToast(TranslationService.get('addSuccess'));
            currentThemeWorldHasBeenChanged = true;
        });
    }

    function removeAllProductConfigsFromThemeWorld(vcatId, products) {
        return dataGen.postAsForm({}, {vcatId: vcatId, proIds: products}, "/themeworld/remove/product/allconfigurations").then(function() {
            ToastService.openStandardToast(TranslationService.get('deleteSuccess'));
            currentThemeWorldHasBeenChanged = true;
        });
    }

    return {
        addProductsToThemeWorld: addProductsToThemeWorld,
        removeProductsFromThemeWorld: removeProductsFromThemeWorld,
        removeTendersFromThemeWorld: removeTendersFromThemeWorld,
        removeLotsFromThemeWorld: removeLotsFromThemeWorld,
        removeVCatsFromThemeWorld: removeVCatsFromThemeWorld,
        removeSuppliersFromThemeWorld: removeSuppliersFromThemeWorld,
        deactivateActiveThemeWorld: deactivateActiveThemeWorld,
        deactivateActiveThemeWorldSearch: deactivateActiveThemeWorldSearch,
        addTendersToThemeWorld: addTendersToThemeWorld,
        addLotsToThemeWorld: addLotsToThemeWorld,
        addVCatsToThemeWorld: addVCatsToThemeWorld,
        addSuppliersToThemeWorld: addSuppliersToThemeWorld,
        getCurrentThemeWorldSearch: getCurrentThemeWorldSearch,
        activateThemeWorldSearch: activateThemeWorldSearch,
        validProducts: validProducts,
        invalidProducts: invalidProducts,
        lotFilter: lotFilter,
        needsIndex: needsIndex,
        activateThemeWorld: activateThemeWorld,
        addAllProductConfigsToThemeWorld: addAllProductConfigsToThemeWorld,
        removeAllProductConfigsFromThemeWorld: removeAllProductConfigsFromThemeWorld,
    };
}